import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@app/shared/services/auth.service';


@Injectable()
export class OnboardingGuardService  {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  public canActivate(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (!this.authService.isLoggedIn) {
      this.authService.goToLogin(true);
      return false;
    }
    // if the url is not the the welcome page or the resume page redirect to First page of onboarding welcome
    if (!state.url.includes('/welcome') && !state.url.includes('/resume')) {
      this.router.navigateByUrl('/getstarted/welcome');
    }
    return true;
  }
}
